export default __webpack_public_path__ + "static/firefox_logo-948f65c705f87abccf1725d4c306aa96.svg";